<template>
    <div>
        <user-table-registration-filter
            :enrollments="enrollments"
            :filtered-enrollments.sync="filteredEnrollments"
        />

        <v-simple-table elevation="1">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Jalur</th>
                    <th>Nama</th>
                    <th>Email</th>
                    <th>ID Line / WA</th>
                    <th>Bukti Pembayaran</th>
                    <th>Mendaftar</th>
                    <th v-if="withAction">Aksi</th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="(enrollment, idx) in enrollmentsData"
                    :key="enrollment.id"
                >
                    <td>
                        {{ idx + 1 }}

                        <v-icon
                            v-if="enrollment.special"
                            color="primary"
                        >
                            mdi-star
                        </v-icon>
                    </td>
                    <td>
                        {{
                            enrollment.registrationLinkTitle
                                ? enrollment.registrationLinkTitle
                                : 'Umum'
                        }}
                    </td>
                    <td>
                        {{ enrollment.name }}
                    </td>
                    <td>
                        {{ enrollment.email }}
                    </td>
                    <td>
                        <a
                            v-if="enrollment.line"
                            :href="`https://line.me/ti/p/~${enrollment.line[1]}`"
                        >
                            {{ enrollment.line[1] }}
                        </a>
                        <a
                            v-if="enrollment.whatsapp"
                            :href="`https://wa.me/${enrollment.whatsapp}`"
                        >
                            {{ enrollment.whatsapp }}
                        </a>

                        <template
                            v-if="!enrollment.line || !enrollment.whatsapp"
                        >
                            {{ enrollment.contact }}
                        </template>
                    </td>
                    <td>
                        <v-btn
                            v-if="enrollment.payment_proof"
                            @click.stop="showProof(enrollment.payment_proof)"
                            icon
                        >
                            <v-icon>mdi-image</v-icon>
                        </v-btn>
                        <span
                            v-else
                            class="warning--text"
                        >
                            Belum membayar
                        </span>
                    </td>

                    <td>
                        {{ enrollment.enrolled_at }}
                    </td>

                    <td v-if="withAction">
                        <v-btn
                            @click.stop="$emit('delete', enrollment.id)"
                            icon
                        >
                            <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                        <template v-if="enrollment.payment_proof">
                            <v-btn
                                @click.stop="$emit('reject', enrollment.id)"
                                icon
                            >
                                <v-icon color="warning">mdi-close</v-icon>
                            </v-btn>
                            <v-btn
                                @click.stop="$emit('activate', enrollment.id)"
                                icon
                            >
                                <v-icon color="primary">mdi-check</v-icon>
                            </v-btn>
                        </template>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <v-dialog
            v-model="proofDialog"
            max-width="70%"
        >
            <v-img :src="selectedProofImageUrl"></v-img>
        </v-dialog>
    </div>
</template>

<script>
import assetUrl from '@/tools/assetUrl'
import UserTableRegistrationFilter from './UserTableRegistrationFilter.vue'

export default {
    props: {
        withAction: {
            type: Boolean,
            default: false,
        },

        enrollments: {
            type: Array,
        },
    },

    components: {
        UserTableRegistrationFilter,
    },

    data() {
        return {
            selectedProofImage: null,
            proofDialog: false,
            filteredEnrollments: [],
        }
    },

    computed: {
        selectedProofImageUrl() {
            return assetUrl(this.selectedProofImage)
        },

        enrollmentsData() {
            return !this.filteredEnrollments
                ? []
                : this.filteredEnrollments.map((e) => {
                      return {
                          ...e,
                          line: e.contact.match(
                              /^\d*\s*\/?\s*([a-zA-Z@]\w+)\s*\/?\s*\d*$/
                          ),
                          whatsapp: e.contact.replace(
                              /^\D*(0|\+62)(\d+)\D*$/,
                              '62$2'
                          ),
                      }
                  })
        },
    },

    methods: {
        showProof(proof) {
            this.selectedProofImage = proof
            this.proofDialog = true
        },
    },
}
</script>
